let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("oSO1O")).then(() => parcelRequire('jLwiM'));